import { useEffect } from 'react';

type useSetLastIdProps = {
  homeId?: string;
};

function useSetLastId({ homeId }: useSetLastIdProps) {
  useEffect(() => {
    if (homeId) {
      localStorage.setItem('lastId', homeId);
    }
  }, [homeId]);
}

export default useSetLastId;
